import { InjectionToken } from '@angular/core';
import { EnvironmentUrlsConfig } from './interfaces/ms-config.interface';

export const ENVIRONMENT_URLS_CONFIG_TOKEN = new InjectionToken<EnvironmentUrlsConfig>('EnvUrlsConfig');
